import { Component } from 'preact'
import WidgetV2Preview from '../components/widget-v2-preview'
import { ThemeFilter, DotsArrowColorFilter, LinkFilter, KeywordFilter } from '../components/filters';
import { __ } from '../../locales'

class V2AverageRatingCarousel extends Component {
  render(props, state) {
    return (
      <WidgetV2Preview
        {...props}
        title={__('widget.review_carousel.name')}
        description={__('widget.review_carousel.description')}
        bestFor={[__('global.about_us_page')]}
        widgetName={'average-carousel-rating-widget'}
        extraParams={[
          'slugs',
          'dotsArrowsColor',
          'keyword'
        ]}
        badgeTitle={__('widget.type.carousel')}
        badgeColor={'#2B59E0'}
        badgeFontColor={'#FFFFFF'}
      >
        <div className={'filters-wrapper mt-5 mb-5'}>
          <ThemeFilter {...props} />
            <LinkFilter
                {...props}
                hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
            />
          <DotsArrowColorFilter {...props} />
          <KeywordFilter {...props} />
        </div>
      </WidgetV2Preview>
    );
  }
}

export default V2AverageRatingCarousel
